import type { RouteCallback } from '@faceup/router'

export const getPageRouteCallback =
  (page: { id: string } | null | undefined): RouteCallback =>
  routes =>
    routes.page({ id: page?.id })

/**
 * Homepage route = first page of the report source, falling back to home so the
 * callback is always navigable (keeps the Home item always visible inside the
 * report-source branch).
 */
export const getHomepageRouteCallback = (
  pages: ReadonlyArray<{ __typename: string; id?: string }>
): RouteCallback => {
  const [homepage] = pages
  if (homepage?.__typename === 'Page' && homepage.id !== undefined) {
    return getPageRouteCallback({ id: homepage.id })
  }
  return routes => routes.home()
}

export const isFromAkutan = (url: string | null | undefined) => {
  if (!url) {
    return false
  }

  try {
    const referrerOrigin = new URL(url).origin
    return referrerOrigin === import.meta.env.VITE_AKUTAN_URL
  } catch {
    return false
  }
}

export const isAkutanPreview = () => isFromAkutan(document.referrer)
